<template>
  <v-row no-gutters>
    <v-col cols="auto" class>
      <v-icon>mdi-information</v-icon>
    </v-col>
    <v-col class="d-flex align-content-start flex-wrap align-center ml-2">
      <template v-for="(char,index) in hintArray">
        <v-img
          v-if="char==='#'"
          class="mx-2"
          aspect-ratio="1"
          :src="require(`@/assets/ic_scan.png`)"
          min-height="16"
          min-width="16"
          max-height="16"
          max-width="16"
          :key="`${index}-icon`"
        ></v-img>
        <span :key="index" v-else :class="[$globalStyle.tableHeaderColor,'body-2']">{{char}}</span>
      </template>
    </v-col>
  </v-row>
</template>
<script>
export default {
  props: ["hint"],
  data: () => ({
    hintArray: []
  }),
  mounted() {
    this.hintArray = this.hint.split("");
  }
};
</script>